import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('settings');

export default {
  computed: {
    ...mapState([
      'apiBaseUrl',
      'settings',
      'language',
    ]),
  },
};
